import messages from 'store/messages';

export function useMessages() {
  return messages;
}
